export enum FeatureFlag {
    publishToWeb = 'publish_to_web',
    allowBilling = 'allow_billing',
    allowEmbeddings = 'allow_embeddings',
    addMembers = 'add_members',
    allowGpt4oMini = 'allow_gpt_4o_mini',
}
